import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { shouldSkipSSE, useSSE } from '@/contexts/SSEContext'
import { useAuthStore } from '@/stores/useAuthStore'

/**
 * Composant invisible qui réagit aux changements de pathname React Router
 * pour connecter/déconnecter le SSE selon que la route le permet.
 *
 * À monter dans le router (LocaleLayout) — pas dans Providers (qui est
 * outside du router et n'a pas accès à useLocation).
 */
export function SSEAutoConnect() {
  const { connect, disconnect } = useSSE()
  const location = useLocation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated())

  useEffect(() => {
    if (!isAuthenticated) {
      disconnect()
      return
    }
    if (shouldSkipSSE(location.pathname)) {
      disconnect()
    } else {
      connect()
    }
  }, [location.pathname, isAuthenticated, connect, disconnect])

  return null
}
